import API from "./API";
import { sessionRenewApi } from "./sessionRenewApi";

export const eventInfo = async (payload) => {
  try {
    return await API.post("/sems/event_info", payload);
  } catch (error) {
     if (error.response && error.response.status === 403) {
      await sessionRenewApi();
      return API.post("/sems/event_info", payload);
    }
    throw error;
  }
};

